// extracted by mini-css-extract-plugin
export var billingAddress = "_qq-g";
export var contactInfo = "_qq-d";
export var customerInfoContainer = "_qq-c";
export var customerInfoContainerMobile = "_qq-h";
export var customerInfoRow = "_qq-a";
export var customerInfoSection = "_qq-b";
export var fullWidthDividerMobile = "_qq-i";
export var imageContainer = "_qq-1";
export var paymentMethod = "_qq-e";
export var priceText = "_qq-6";
export var priceTextMobile = "_qq-7";
export var product = "_qq-0";
export var productImage = "_qq-2";
export var productInfo = "_qq-4";
export var productMobile = "_qq-9";
export var productTitle = "_qq-8";
export var quantityBadge = "_qq-3";
export var quantityText = "_qq-5";
export var shippingAddress = "_qq-f";